import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-billing-payments',
  templateUrl: './billing-payments.component.html',
  styleUrls: ['./billing-payments.component.scss']
})
export class BillingPaymentsComponent implements OnInit {

  @Input() payments: any = [];
  constructor() { }

  ngOnInit() {
  }

  getDateFrmt(item) {
    if (item.payment_type === 'RazorPay') {
      const milliseconds = Number(item.created_at) * 1000;
      const date = new Date(milliseconds);
      return date.toLocaleString();
    } else if (item.payment_type === 'Paypal') {
      const dateObject = new Date(item.created_at);
      const formattedDate = `${String(dateObject.getDate()).padStart(2, '0')}/${String(dateObject.getMonth() + 1).padStart(2, '0')}/${dateObject.getFullYear()}`;
      const formattedTime = `${String(dateObject.getHours()).padStart(2, '0')}:${String(dateObject.getMinutes()).padStart(2, '0')}:${String(dateObject.getSeconds()).padStart(2, '0')}`;
      const result = `${formattedDate}, ${formattedTime}`;
      return result;
    } else if (item.payment_type === 'Stripe') {
      const date = new Date(Number(item.created_at) * 1000);
      const year = date.getFullYear();
      const month = ('0' + (date.getMonth() + 1)).slice(-2); // Months are zero-indexed, so we add 1
      const day = ('0' + date.getDate()).slice(-2);
      const hours = ('0' + date.getHours()).slice(-2);
      const minutes = ('0' + date.getMinutes()).slice(-2);
      const seconds = ('0' + date.getSeconds()).slice(-2);
      const formattedDateTime = day + '/' + month + '/' + year + ', ' + hours + ':' + minutes + ':' + seconds;
      return formattedDateTime;
    }
    return item.created_at;
  }

  getAmount(item) {
    if (item.payment_type === 'RazorPay') {
      return (Number(item.amount) / 100).toFixed(2);
    }
    return item.amount;
  }

}
